import { render, staticRenderFns } from "./ProviderPriceForm.vue?vue&type=template&id=692c648c&"
import script from "./ProviderPriceForm.vue?vue&type=script&lang=js&"
export * from "./ProviderPriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports